export default __webpack_public_path__ + "/assets/abm-interactive-map.png";